import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full py-12 md:py-16 px-4 md:px-8" data-id="element-104">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-106">
          <h2 className="font-handwritten text-4xl md:text-5xl lg:text-6xl text-forestGreen font-bold leading-tight mb-6" data-id="element-107">
            "Felix leckte ständig seine Pfoten – die Ursache war nicht die Haut"
          </h2>

          <p className="font-serif text-lg md:text-xl text-warmBrown/90 leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-108">
            Was ich nach einem Jahr Suche endlich herausgefunden habe – und kein
            Tierarzt mir sagte.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="w-full relative rounded-2xl overflow-hidden shadow-xl border-4 border-white rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-109">
          {/* Using a warm, slightly vintage-toned image of a dog */}
          <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&q=80" alt="Hund leckt seine Pfote" className="w-full h-auto object-cover aspect-[4/3] md:aspect-[16/9]" data-id="element-110" />
          <div className="absolute inset-0 bg-warmBrown/10 mix-blend-overlay pointer-events-none" data-id="element-111"></div>
        </motion.div>
      </div>
    </section>;
}